<template>
  <path
    d="M4 3.00018H20C20.55 3.00018 21 3.45018 21 4.00018C21 4.55018 20.55 5.00018 20 5.00018H4C3.45 5.00018 3 4.55018 3 4.00018C3 3.45018 3.45 3.00018 4 3.00018Z"
  />
</template>
